import { request, extractResponseData } from './api'
const routeApi = '/api/menu-access'

// GET /api/menu-access/for-user
// ใช้หลัง login → คืน list ของ menu_key ที่ user ปัจจุบันเห็น (filter ตาม JWT role + plant_no)
export async function getMenuAccessForUser() {
  const url = `${routeApi}/for-user`
  try {
    const response = await request('GET', url, {}, true)
    return extractResponseData(response)
  } catch (error) {
    console.error('Error in getMenuAccessForUser:', error)
    throw error
  }
}

// GET /api/menu-access
// Admin fetch full matrix ของ plant ตัวเอง (backend filter ด้วย JWT.plant_no)
// Response: [{ plantNo, role, menuKey, enabled, updatedAt, updatedBy }, ...]
export async function getMenuAccessMatrix() {
  const url = routeApi
  try {
    const response = await request('GET', url, {}, true)
    return extractResponseData(response)
  } catch (error) {
    console.error('Error in getMenuAccessMatrix:', error)
    throw error
  }
}

// PUT /api/menu-access
// Admin bulk upsert; backend enforce JWT.plant_no === body.plantNo (403 otherwise)
// payload = { plantNo, rows: [{ role, menuKey, enabled }, ...] }
export async function updateMenuAccess(payload) {
  const url = routeApi
  try {
    const response = await request('PUT', url, payload, true)
    return extractResponseData(response)
  } catch (error) {
    if (error?.response?.data) {
      return extractResponseData(error.response)
    }
    console.error('Error in updateMenuAccess:', error)
    throw error
  }
}
